import angular from 'angular';
import { forEach, range, map } from 'lodash';
import FILTER_PARAMS from '../values/filter-params';

const PRICE_OPTIONS = range(10000000, 65000000, 5000000);
const MIN_SQ_FT_OPTIONS = range(1500, 4500, 500);

module.exports = angular.module('market.components.od-listing-filter-form', [])
.component('odListingFilterForm', {
  bindings: {
    filters: '=?',
    onFiltersChanged: '&',
  },
  template: require('./od-listing-filter-form.jade')(),
  controller: class {
    constructor(Segment, numberFilter) {
      this.PRICE_OPTIONS = PRICE_OPTIONS;
      this.MIN_SQ_FT_SELECT_OPTIONS = map(MIN_SQ_FT_OPTIONS, sqFtOption => ({
        value: sqFtOption,
        label: `${numberFilter(sqFtOption)} sq ft`,
      }));
      this.Segment = Segment;
    }

    applyFilters() {
      // Mark this as a user triggered search
      this.filters.u = '1';
      forEach(this.filters, (value, key) => {
        if (!value || value === '' || value === 'false') {
          // value of undefined in state params clears that key from state altogether
          this.filters[key] = undefined;
        }
      });
      this.onFiltersChanged();
    }

    clearFilters() {
      FILTER_PARAMS.forEach((param) => {
        this.filters[param] = undefined;
      });
      // Mark this as a user triggered search
      this.filters.u = true;
      this.filters['active'] = true;

      this.onFiltersChanged();

      this.Segment.track('filters.reset');
    }
  }
}).name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-listing-filter-form.js
 **/